import {Pipe, PipeTransform} from '@angular/core';
import {ImportFileType} from "@services";
import {capitalCase} from 'change-case';

@Pipe({
    name: 'importFileType',
    standalone: true
})
export class ImportFileTypePipe implements PipeTransform {
    transform(value: ImportFileType | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case ImportFileType.Employees: return "Employees";
            case ImportFileType.Vacations: return "Vacations";
            case ImportFileType.Materials: return "Materials";
            case ImportFileType.Bins: return "Bins";
            case ImportFileType.HALB: return "HALB";
            case ImportFileType.StorageUnits: return "Storage Units (LX03)";
            case ImportFileType.StorageUnits210: return "210 (Damaged)";
            case ImportFileType.StorageUnits216: return "216 (Missing)";
            case ImportFileType.StorageUnits260: return "260 (Putaway)";
            case ImportFileType.StorageUnits999: return "999 (Cycle count)";
            case ImportFileType.StorageUnitsLT22: return "LT22 Refill";
            case ImportFileType.MB51: return "MB51";
            case ImportFileType.TmReport: return "TM Report";
            case ImportFileType.GlCodes: return "GL Codes";
            default: return capitalCase(value);
        }
    }
}

